module.exports = __webpack_public_path__ + "img/status-eveywhere.1b84025e.png";